export default {
  root: {
    border: '1px solid #DFE3E8;',
    borderRadius: '4px',
    padding: '24px',
    boxShadow: '0 0 0 0 rgba(255, 105, 135, .3)'
  }
};
